import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Paper,
  FormControl,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import { useContext } from "react";
import AppDataContext from "../../../common/appContext";
import {
  getDropDown,
  getInputBox,
} from "../../../sharedComponents/formFields/LabelInFormFields";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";
import AppConstatnts from "../../../common/AppConstants";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";

const InternationalTeamExpViewUpdate = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  viewProfile,
  setAlert,
  setAlertType,
  setAlertMessage,
  // user,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    id: 0,
    playerID: playerID,
    eventId: eventId,
    expYear: 0,
    countryId: 0,
    countryName: "",
    experience: "",
    userBy: user?.loginID,
    mode: null,
  };
  const defaultErrors = {
    expYear: false,
  };
  const defaultErrorMsg = {
    expYear: "",
  };
  const [intTeamExpGridData, setIntTeamExpGridData] = useState([]);
  const [intTeamExpFormData, setIntTeamExpFormData] = useState({});
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [countryDropdownList, setCountryDropdownList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedRowID, setDeletedRowId] = useState(-1);
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );

  const columns = [
    { field: "id", hide: true, flex: 1 },
    {
      field: "expYear",
      headerName: "International Experience Year",
      width: 250,
      flex: columnFlex,
    },
    {
      field: "countryName",
      headerName: "International Experience Country",
      width: 250,
      flex: columnFlex,
    },
    {
      field: "experience",
      headerName: "International Experience",
      width: 200,
      flex: columnFlex,
    },
  ];

  useEffect(() => {
    fetchDropdownDataforPlayer();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    fetchDropdownDataforPlayer();
    setIntTeamExpGridData(gridPropsData);
    setIntTeamExpFormData(formData);
  }, [gridPropsData]);

  //---UTILs---

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };

  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  //dynamic error validation, check for all keys,
  //if in-case multiple error validations in future
  const validateErrors = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  const checkIfSaveBtnDisabled = () => {
    return intTeamExpFormData.countryName ||
      intTeamExpFormData.expYear ||
      intTeamExpFormData.experience
      ? false
      : true;
  };

  //---HANDLERS---

  //single handler to open and close confirmation box for delete
  const handleOpenCloseConfirmationBox = (val) => {
    if (val === false) {
      setDeletedRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. find the National/Int Team experience details to edit from grid data
  //2. set the input boxes with National/Int Team experience details to edit
  //3. set userBy to current user -- for DB record
  const handleRowEditClick = (id) => {
    resetError();
    setIsUpdate(true);
    let result = intTeamExpGridData.find((e, i) => {
      return e.id === id;
    });
    setIntTeamExpFormData({ ...result, userBy: user?.loginID });
  };

  const handleRowDeleteClick = (id) => {
    setDeletedRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //reset the input boxes with initially declared empty formData
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setIntTeamExpFormData(formData);
  };

  //1. validate then call api to save
  //2. after save reset necessary values
  const handleSaveCLick = () => {
    if (!checkIfSaveBtnDisabled() && validateErrors()) {
      const result = handleSubmit(intTeamExpFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. after delete reset necessary values
  const handleDeleteClick = () => {
    let record = intTeamExpGridData.find((e, i) => {
      return e.id === deletedRowID;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(
          true,
          "success",
          "National/International Team Experience record deleted Successfully."
        );
      }
    }
  };

  const handleInputChange = (e, key) => {
    let value = e.target.value;
    let defaultVal = "";
    switch (key) {
      case "expYear":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.YEAR_REGEX)
        )
          toggleError(key, true, "Invalid Year");
        else toggleError(key, false, "");
        defaultVal = 0;
        break;
      case "countryId":
        let result = countryDropdownList.find((c, i) => {
          return c.childID === value;
        });
        setIntTeamExpFormData({
          ...intTeamExpFormData,
          [key]: value || null,
          countryName: result.childID ? result.childName : "",
        });
        return;
    }
    setIntTeamExpFormData({
      ...intTeamExpFormData,
      [key]: value || defaultVal,
    });
  };

  //---APIs---

  const fetchDropdownDataforPlayer = async () => {
    try {
      const countryList = await PlayerProfileService.getPlayerCountryList();
      setCountryDropdownList([
        { childID: "", childName: "None" },
        ...countryList.data,
      ]);
    } catch (error) {
      console.error("Error while fetching Dropdown data:", error);
    }
  };

  //to create, update or delete a record -- common api
  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const result = await PlayerProfileService.insertUpdateIntTeamExpDetails(
        formData
      );
      if (result) {
        getUpdatedIntTeamExpGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedIntTeamExpGridData = async () => {
    try {
      const result = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setIntTeamExpGridData(result.data.nationalIntExp);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper square elevation={5} className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant="subtitle1"
              fontWeight="medium"
              color="secondary"
            >
              National/International Team Experience
            </Typography>
          </Grid>
          {!viewProfile ? (
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className={classes.inputSectionPadding}
            >
              <Box>
                {isUpdate ? (
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <TitleTooltip title="cancel">
                      <CancelOutlinedIcon
                        sx={{ color: styles.cancelButton.cancelIconColor }}
                      />
                    </TitleTooltip>
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveCLick}
                >
                  <TitleTooltip title="Save national/international team details">
                    <SaveOutlinedIcon />
                  </TitleTooltip>
                </Button>
              </Box>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {!viewProfile ? (
          <Grid
            key={0}
            container
            pl={2}
            pr={2}
            spacing={2}
            justifyContent={"start"}
          >
            <Grid item lg={4} md={6} sm={12} xs={12}>
              {getInputBox(
                "International Experience Year",
                intTeamExpFormData.expYear,
                (e) => handleInputChange(e, "expYear"),
                false,
                "text",
                error.expYear
                // errorMessage.expYear
              )}
            </Grid>
            <Grid item lg={4} md={6} sm={12} xs={12}>
              {getDropDown(
                "International Experience Country",
                intTeamExpFormData.countryId,
                (e) => handleInputChange(e, "countryId"),
                countryDropdownList
              )}
            </Grid>
            <Grid item lg={4} md={6} sm={12} xs={12}>
              {getInputBox(
                "International Experience",
                intTeamExpFormData.experience,
                (e) => handleInputChange(e, "experience")
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={intTeamExpGridData}
            viewProfile={viewProfile}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => handleOpenCloseConfirmationBox(false)}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};

export default React.memo(InternationalTeamExpViewUpdate);
